var map = {
	"./asset-hyperlink.json": 4381,
	"./blockquote.json": 1198,
	"./document.json": 9291,
	"./embedded-asset-block.json": 6940,
	"./embedded-entry-block.json": 10,
	"./embedded-entry-inline.json": 6414,
	"./embedded-resource-block.json": 9083,
	"./embedded-resource-inline.json": 6426,
	"./entry-hyperlink.json": 260,
	"./heading-1.json": 3405,
	"./heading-2.json": 9699,
	"./heading-3.json": 6,
	"./heading-4.json": 6879,
	"./heading-5.json": 5230,
	"./heading-6.json": 6773,
	"./hr.json": 2419,
	"./hyperlink.json": 8865,
	"./list-item.json": 7378,
	"./ordered-list.json": 2150,
	"./paragraph.json": 3590,
	"./resource-hyperlink.json": 5113,
	"./table-cell.json": 9098,
	"./table-header-cell.json": 2030,
	"./table-row.json": 5225,
	"./table.json": 3725,
	"./text.json": 7195,
	"./unordered-list.json": 5968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8852;